<template>
  <div class="page-form">
    <h3 class="title">发货单自动删除时间设置</h3>

    <div class="form-container">
      <div class="tools">
        <form-button name="返回" type="primary" @click="$router.go(-1)" />
        <form-button name="提交" type="primary" @click="saveSetting" />
      </div>
      <el-form inline size="mini" label-width="100px" :model="conditions">
        <el-row>
          <el-col :lg="8" :md="12">
            <el-form-item label="申请人">
              <el-input v-model="conditions.createdByName" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="申请时间">
              <el-input v-model="conditions.createdDate" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="所属部门">
              <el-input v-model="conditions.deptName" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="设置时长">
              <el-select v-model="conditions.value">
                <el-option value="3" label="3天" />
                <el-option value="5" label="5天" />
                <el-option value="7" label="7天" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import { apiAddOutTime, apiFindALSetTime } from '@/api/applyForGoods'
export default {
  data() {
    return {
      conditions: {
        deptName: '',
        createdById: '',
        createdByName: '',
        createdDate: '',
        value: ''
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    apiFindALSetTime().then(({ data }) => {
      this.conditions.value = data.value
    })
    this.conditions.createdByName = this.userInfo.name
    this.conditions.createdById = this.userInfo.code
    this.conditions.createdDate = this.$utilsCommon.parseTime(
      new Date().getTime(),
      '{y}-{m}-{d}'
    )
    this.conditions.deptName = this.userInfo.deptName
  },
  methods: {
    saveSetting() {
      if (!this.conditions.value) {
        return this.$message.error('请选择设置时间！')
      }
      const params = {
        ...this.conditions
      }
      apiAddOutTime(params).then(res => {
        if (res.status === 1) {
          this.$message.success('设置成功！')
        }
      })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/autoRemove.vue